//
// KEEP IN SYNC: every `condition_category_primary` value from
// `processing/topics/parking/helper/condition_category_primary.lua` needs a colour here.
// The priority order lives in that Lua file; the order of this `==` cascade does not matter.

import type { StyleLayer } from './utils/types'

export const layers_parkingTilda_street_default: StyleLayer[] = [
  {
    id: 'street parking lines',
    type: 'line',
    filter: ['has', 'capacity'],
    paint: {
      'line-color': [
        'case',
        ['==', ['get', 'condition_category_primary'], 'no_stopping'],
        '#EB0000',
        ['==', ['get', 'condition_category_primary'], 'bus_lane'],
        '#EB0000',
        ['==', ['get', 'condition_category_primary'], 'no_parking'],
        '#F97316',
        ['==', ['get', 'condition_category_primary'], 'disabled_private'],
        '#5B21B6',
        ['==', ['get', 'condition_category_primary'], 'disabled'],
        '#8B5CF6',
        ['==', ['get', 'condition_category_primary'], 'loading'],
        '#93D6FF',
        ['==', ['get', 'condition_category_primary'], 'charging'],
        '#5EF20C',
        ['==', ['get', 'condition_category_primary'], 'taxi'],
        '#FEE13A',
        ['==', ['get', 'condition_category_primary'], 'car_sharing'],
        '#6B7280',
        ['==', ['get', 'condition_category_primary'], 'private'],
        '#FF7162',
        ['==', ['get', 'condition_category_primary'], 'assumed_private'],
        '#FF7162',
        ['==', ['get', 'condition_category_primary'], 'vehicle_restriction'],
        '#6B7280',
        ['==', ['get', 'condition_category_primary'], 'access_restriction'],
        '#4B5563',
        ['==', ['get', 'condition_category_primary'], 'maxweight'],
        '#6B7280',
        ['==', ['get', 'condition_category_primary'], 'mixed'],
        '#2EB499',
        ['==', ['get', 'condition_category_primary'], 'residents'],
        '#BE3C3C',
        ['==', ['get', 'condition_category_primary'], 'paid'],
        '#0E7490',
        ['==', ['get', 'condition_category_primary'], 'time_limited'],
        '#60A5FA',
        ['==', ['get', 'condition_category_primary'], 'unspecified'],
        '#4B5563',
        ['==', ['get', 'condition_category_primary'], 'free'],
        '#16A34A',
        ['==', ['get', 'condition_category_primary'], 'assumed_free'],
        '#16A34A',
        '#4B5563',
      ],
      'line-opacity': [
        'case',
        ['match', ['get', 'staggered'], ['yes'], true, false],
        0.5,
        ['match', ['get', 'informal'], ['yes'], true, false],
        0.5,
        1,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 2, 20, 16],
    },
  },
]
